import React from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";

const TABLE_SCROLL_Y = 360;

const CustomerReturnInvoiceList = ({ list, scrollY = TABLE_SCROLL_Y }) => {
	const columns = [
		{ title: "ID", dataIndex: "id", key: "id" },
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (date) => moment(date).format("DD/MM/YYYY"),
		},
		{ title: "Total Amount", dataIndex: "total_amount", key: "total_amount" },
		{ title: "Note", dataIndex: "note", key: "note" },
		{
			title: "Sale Invoice No",
			dataIndex: "saleInvoice_id",
			key: "saleInvoice_id",
			width: 190,
			ellipsis: false,
			render: (saleInvoice_id) => (
				<Link to={`/sale/${saleInvoice_id}`}>{saleInvoice_id}</Link>
			),
		},
	];

	const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

	return (
		<div className="customer-detail-section">
			<h5 className="customer-detail-section-heading">All Return Information</h5>
			<div className="detail-page-table-wrap">
				<Table
					scroll={{ x: 900, y: scrollY }}
					loading={!list}
					columns={columns}
					dataSource={list ? addKeys(list) : []}
					size="small"
				/>
			</div>
		</div>
	);
};

export default CustomerReturnInvoiceList;
